import { nanoid } from "@reduxjs/toolkit";
import ObjectId from "bson-objectid";
import { validate as isUUIDValid } from "uuid";
import { parse, isValid, format, parseISO } from "date-fns";
import {
  checkIfItemExists,
  dateFormatsForRowColumnAndSort,
  dateUnitForRowColumnAndSort,
  filterDateFormats,
  relativeDateUnit,
  dateUnitForBuildQueryFromThisDateToThisDate,
  modifiedQuery,
  modifiedSort,
  lastAndNextDates,
  nowDates,
  VizType,
  measureOptionObjects,
} from "./vizardFunctions";
const buildReduxStateFromResponse = (
  data,
  columnData = [],
  Sheetid,
  dataSourceID
) => {
  let query = {
    rows: [],
    groupByFields: [],
    valueColumns: [],
    filters: [],
    tooltip: [],
    rowLimit: 500,
  };
  let vizType = "simpleTable";
  let quickTableObject = null;
  let calculatedFieldObject = null;
  // const demoQuery = {};  "Table, Bar Chart, Pie Chart, Line Chart, Big Number Chart"
  // // console.log(columnData);
  try {
    const sort = [];
    const {
      rows,
      columns,
      values,
      filters,
      visualization,
      rowLimit: rRowLimit,
      sort: resSort,
    } = data.response || {};

    // console.log(rows);

    // console.log(columns);

    // console.log(values);

    // console.log(filters);

    // console.log(visualization);

    // console.log(resSort);

    // console.log(rRowLimit);

    // rows
    if (checkIfItemExists(rows)) {
      rows.forEach((item) => {
        const columnItem = columnData.find(
          (ColumnItem) => ColumnItem.columnName === item.field
        );
        // console.log(columnItem);
        let rowObject = null;
        if (columnItem) {
          if (columnItem.dataType === "String") {
            rowObject = {
              ...columnItem,
              nanoId: nanoid(),
            };
          } else if (columnItem.dataType === "Date") {
            if (item.dateFormat) {
              rowObject = {
                ...columnItem,
                nanoId: nanoid(),
                dateFormat: {
                  value: dateFormatsForRowColumnAndSort(item.dateFormat),
                },
                dateUnit: dateUnitForRowColumnAndSort(item.dateFormat),
                yearType: item?.yearType ? item.yearType : "FY",
              };
            } else {
              console.error(
                `dateFormat is undefined or null ${item.dateFormat}`
              );
              rowObject = null;
            }
          }
        } else {
          console.error(`column is undefined`);
        }
        if (rowObject) {
          query.rows.push(rowObject);
        }
      });
    }
    // columns
    if (checkIfItemExists(columns)) {
      // console.log(columns);
      columns.forEach((item) => {
        const columnItem = columnData.find(
          (ColumnItem) => ColumnItem.columnName === item.field
        );
        let columnObject = null;
        // console.log(columnItem);
        if (columnItem) {
          if (columnItem.dataType === "String") {
            columnObject = {
              ...columnItem,
              nanoId: nanoid(),
            };
          } else if (columnItem.dataType === "Date") {
            if (item.dateFormat) {
              columnObject = {
                ...columnItem,
                nanoId: nanoid(),
                dateFormat: {
                  value: dateFormatsForRowColumnAndSort(item.dateFormat),
                },
                dateUnit: dateUnitForRowColumnAndSort(item.dateFormat),
                yearType: item?.yearType ? item.yearType : "FY",
              };
            } else {
              console.error(
                `dateFormat is undefined or null ${item.dateFormat}`
              );
              columnObject = null;
            }
          } else if (columnItem.dataType === "Number") {
            console.error("date type is number in columns");
          }
        } else {
          console.error(`column is undefined`);
        }
        if (columnObject) {
          query.groupByFields.push(columnObject);
        }
      });
    }
    // values
    if (checkIfItemExists(values)) {
      values.forEach((item, index) => {
        const {
          field,
          measure: measureValue,
          quicktabletype,
          UUID,
          calculatedField,
          formula,
        } = item;
        const display = index === 0 ? "bar" : "line";
        let measure;
        if (["sum", "max", "min", "count", "distinct"].includes(measureValue)) {
          measure = measureOptionObjects.find(
            (measureItem) => measureItem.value === measureValue.toUpperCase()
          );
        } else {
          measure = {
            label: "Sum",
            value: "SUM",
          };
        }
        const columnItem = columnData.find(
          (ColumnItem) => ColumnItem.columnName === field
        );
        // console.log(columnItem);
        let numberObject = {
          decimalPlaces: 2,
          factor: 1,
          prefix: "$",
          sufix: "M",
          mode: "Auto",
        };
        if (
          quicktabletype &&
          [
            "percentageOfRowTotal",
            "percentageOfColumnTotal",
            "percentageOfGrandTotal",
            "tableDifferenceDownPercentage",
            "tableDifferenceAcrossPercentage",
          ].includes(quicktabletype)
        ) {
          numberObject = {
            decimalPlaces: 1,
            factor: 0.01,
            prefix: "",
            sufix: "%",
            mode: "Manual",
          };
        }

        if (calculatedField && formula) {
          calculatedFieldObject = {
            name: field,
            rename: field,
            formula,
            uuid: UUID,
            dataType: "Number",
            columnType: "calculatedField",
          };
          const columnClone = {
            rename: field,
            columnName: field,
            dataType: "Number",
            columnType: "calculatedField",
            formula,
            uuid: UUID,
            nanoId: nanoid(),
            numberObject,
            display,
            measure,
          };
          if (quicktabletype) {
            quickTableObject = {
              nanoId: columnClone.nanoId,
              quickTableKey: `${columnClone?.measure?.value}_${columnClone.columnName}`,
              quickOption: quicktabletype,
            };
          }
          // console.log(columnClone);
          query.valueColumns.push(columnClone);
        } else {
          if (columnItem) {
            const columnClone = {
              ...columnItem,
              nanoId: nanoid(),
              numberObject,
              display,
              measure,
            };
            if (quicktabletype) {
              quickTableObject = {
                nanoId: columnClone.nanoId,
                quickTableKey: `${columnClone?.measure?.value}_${columnClone.columnName}`,
                quickOption: quicktabletype,
              };
            }
            // console.log(columnClone);
            query.valueColumns.push(columnClone);
          }
        }
      });
    }
    // sort
    if (resSort?.field && resSort?.order) {
      // console.log(resSort);
      let combinedArray = [
        ...query.rows,
        ...query.groupByFields,
        ...query.valueColumns,
      ];
      // console.log(combinedArray);

      let sortObject = null;
      const foundedItem = combinedArray.find(
        (item) => item.columnName === resSort.field
      );
      // console.log(foundedItem);
      let measure, columnName;
      if (
        foundedItem.dataType === "Number" &&
        [("SUM", "MAX", "MIN", "COUNT")].includes(foundedItem?.measure?.value)
      ) {
        measure = measureOptionObjects.find(
          (measureItem) => measureItem.value === foundedItem?.measure?.value
        );
      } else {
        measure = {
          label: "Sum",
          value: "SUM",
        };
      }
      // console.log(measure);
      if (foundedItem.dataType === "Number") {
        columnName = `${measure.value.toUpperCase()}_${foundedItem.rename}`;
      } else if (foundedItem.dataType === "String") {
        columnName = `${foundedItem.rename}`;
      }
      if (measure && foundedItem) {
        sortObject = {
          column: columnName,
          dataType: foundedItem.dataType,
          _id: new ObjectId().toHexString(),
          order: resSort.order === "descending" ? "DESC" : "ASC",
          columnId: foundedItem?.nanoId,
        };
      }
      if (sortObject === null) {
        console.error("Could not find measureObject or foundedItem");
      } else {
        sort.push(sortObject);
      }
    }
    // vizType
    if (visualization) {
      const firstVizType = visualization.split(",")[0].trim(); // Get the first value
      vizType = VizType(firstVizType);
    }
    // filter
    if (Array.isArray(filters) && checkIfItemExists(filters)) {
      filters.forEach((filter) => {
        const columnItem = Array.isArray(columnData)
          ? columnData.find((ColumnItem) => {
              if (isUUIDValid(filter.UUID)) {
                if (ColumnItem.uuid === filter.UUID) {
                  return ColumnItem.uuid === filter.UUID;
                } else {
                  return ColumnItem.columnName === filter.field;
                }
              } else {
                return ColumnItem.columnName === filter.field;
              }
            })
          : null;
        // console.log(columnItem);

        if (columnItem) {
          let filterObject = null;
          let commonfilterKeyValuePairObject = {
            _id: columnItem._id,
            rename: columnItem.rename,
            uuid: columnItem.uuid,
            dataType: columnItem.dataType,
            columnName: columnItem.columnName,
            nanoId: nanoid(),
            selectedOperator: "IN",
            isAll: false,
            visibleFilter: true,
            isCommonFilter: false,
            Sheetid: Sheetid || columnItem.Sheetid || null,
            filterComponentType: "MultiValueDropdown",
            dataSourceID,
          };
          // console.log(columnItem?.dataType);
          // console.log(filter.measure);

          if (columnItem?.dataType === "String") {
            filterObject = {
              ...commonfilterKeyValuePairObject,
              selectedFilterValues: filter.values || [],
            };
            // console.log(filterObject);
          } else if (columnItem?.dataType === "Number") {
            let measure;
            if (
              [
                "sum",
                "max",
                "min",
                "count",
                "distinct",
                "noCalculation",
              ].includes(filter.measure)
            ) {
              // console.log("ji");

              const localMeasureObject = measureOptionObjects.find(
                (measureItem) =>
                  measureItem.value === filter.measure.toUpperCase()
              );
              measure = localMeasureObject.value;
            } else {
              measure = "SUM";
            }
            // console.log(measure);

            if (["GreaterThan", "LessThan"].includes(filter.operator)) {
              filterObject = {
                ...commonfilterKeyValuePairObject,
                selectedOperator:
                  filter.operator === "GreaterThan"
                    ? ">"
                    : filter.operator === "LessThan"
                    ? "<"
                    : null,
                selectedMeasure: measure,
                minValue: filter.values[0] || null,
                maxValue: filter.maxValue || null,
              };
            }
            if (filter.operator === "BETWEEN") {
              filterObject = {
                ...commonfilterKeyValuePairObject,
                selectedOperator: filter.operator,
                selectedMeasure: measure,
                minValue: filter.values[0] || null,
                minValue: filter.values[1] || null,
              };
            }
          } else if (columnItem?.dataType === "Date") {
            filterObject = null;
            if (filter.operator === "BETWEEN") {
              if (filter?.relative) {
                // console.log(filter.dateFormat);
                if (filter.Tense && filter.quantum && filter.DateUnit) {
                  filterObject = {
                    ...commonfilterKeyValuePairObject,
                    nanoId: nanoid(),
                    selectedOperator: filter.operator,
                    format: filterDateFormats(filter.DateUnit),
                    dateUnit: relativeDateUnit(filter.DateUnit),
                    filterField: relativeDateUnit(filter.DateUnit),
                    isRelevant: false,
                    isRelativeDate: true,
                    filterComponentType: "relativeDate",
                    relativeDateIs:
                      filter.quantum === 1 && filter.Tense !== "This"
                        ? lastAndNextDates(
                            filter.Tense,
                            dateUnitForBuildQueryFromThisDateToThisDate(
                              filter.DateUnit
                            )
                          )
                        : filter.quantum === 1 && filter.Tense === "This"
                        ? nowDates(
                            filter.Tense,
                            dateUnitForBuildQueryFromThisDateToThisDate(
                              filter.DateUnit
                            )
                          )
                        : `${filter.Tense} ${filter.quantum} ${filter.DateUnit}`,
                  };
                } else {
                  console.error(
                    ` something is undefined or null out these values Tense: ${filter.Tense}, quantum: ${filter.quantum}, DateUnit: ${filter.DateUnit}`
                  );
                }
              } else {
                const isDateValid = (date) => {
                  const parsedDate = parse(date, "yyyy-MM-dd", new Date());
                  return (
                    isValid(parsedDate) && date.match(/^\d{4}-\d{2}-\d{2}$/)
                  );
                };
                const allDatesValid = filter.values.every(isDateValid);
                if (!allDatesValid) {
                  filterObject = null;
                } else {
                  const formattedDates = filter.values.map((date) => {
                    // console.log(date);
                    return format(parseISO(date), "dd/MM/yyyy");
                  });

                  // console.log(formattedDates);

                  filterObject = {
                    ...commonfilterKeyValuePairObject,
                    nanoId: nanoid(),
                    selectedOperator: filter.operator,
                    format: filterDateFormats(filter.dateFormat),
                    dateUnit: filter.dateFormat,
                    filterField: filter.dateFormat,
                    isRelevant: false,
                    isRelativeDate: false,
                    minValue: formattedDates[0],
                    maxValue: formattedDates[1],
                  };
                }
              }
            }
            if (filter.operator === "IN") {
              if (filter?.relative) {
                // console.log(filter.dateFormat);
                // console.log(
                //   `${filter.Tense} ${filter.quantum} ${filter.DateUnit}`
                // );
                // console.log(
                //   dateUnitForBuildQueryFromThisDateToThisDate(filter.DateUnit)
                // );
                if (
                  dateUnitForBuildQueryFromThisDateToThisDate(filter.DateUnit)
                ) {
                  filterObject = {
                    ...commonfilterKeyValuePairObject,
                    nanoId: nanoid(),
                    selectedOperator: "BETWEEN",
                    format: filterDateFormats(filter.dateFormat),
                    dateUnit: relativeDateUnit(filter.dateFormat),
                    filterField: relativeDateUnit(filter.dateFormat),
                    isRelevant: false,
                    isRelativeDate: true,
                    relativeDateIs:
                      filter.quantum === 1 && filter.Tense !== "This"
                        ? lastAndNextDates(
                            filter.Tense,
                            dateUnitForBuildQueryFromThisDateToThisDate(
                              filter.DateUnit
                            )
                          )
                        : filter.quantum === 1 && filter.Tense === "This"
                        ? nowDates(
                            filter.Tense,
                            dateUnitForBuildQueryFromThisDateToThisDate(
                              filter.DateUnit
                            )
                          )
                        : `${filter.Tense} ${filter.quantum} ${filter.DateUnit}`,
                  };
                } else {
                  console.error(`filter.DateUnit is ${filter.DateUnit}`);
                  filterObject = null;
                }
              } else {
                filterObject = {
                  ...commonfilterKeyValuePairObject,
                  nanoId: nanoid(),
                  selectedOperator: "IN",
                  format: filterDateFormats(filter.dateFormat),
                  dateUnit: filter.dateFormat,
                  filterField: filter.dateFormat,
                  isRelevant: false,
                  relativeDateIs: "",
                  selectedFilterValues: filter.values,
                };
              }
            }
          } else {
            filterObject = null;
          }
          if (filterObject) {
            // console.log(filterObject);
            query.filters.push(filterObject);
          } else {
            console.error("filterObject is null");
          }
        } else {
          console.error("columnItem is null");
        }
      });
    }
    // limit
    if (Array.isArray(rRowLimit) && rRowLimit.length === 1) {
      if (rRowLimit[0]) {
        query.rowLimit = Number(rRowLimit[0]);
      } else {
        console.error(`rRowLimit[0]: ${rRowLimit[0]} is in array`);
      }
    } else if (rRowLimit) {
      query.rowLimit = Number(rRowLimit);
    }
    // modifying the query
    const finalQuery = modifiedQuery(query, vizType) ?? query;
    // modifying the sort based on modified query
    const finalSort =
      sort.length && query.groupByFields.length
        ? modifiedSort(sort, finalQuery)
        : sort;
    // console.log(sort);
    const {
      rows: finalRows,
      columns: finalColumns,
      values: finalValues,
      filters: finalFilters,
      visualization: finalVisualization,
      rowLimit: finalrRowLimit,
      sort: finalResSort,
    } = finalQuery || {};

    // console.log(finalRows);

    // console.log(finalColumns);

    // console.log(finalValues);

    // console.log(finalFilters);

    // console.log(finalVisualization);

    // console.log(finalrRowLimit);

    // console.log(finalResSort);

    // console.log();

    // console.log(quickTableObject);
    // console.log(calculatedFieldObject);

    return {
      query: finalQuery,
      sort: finalSort,
      vizType: vizType,
      quickTable: quickTableObject,
      calculatedField: calculatedFieldObject,
    };
  } catch (error) {
    // console.log("there was an error");
    console.error(error);

    return {
      query,
      sort: [],
      vizType: vizType,
      quickTable: quickTableObject,
      calculatedField: calculatedFieldObject,
    };
  }
};

export { buildReduxStateFromResponse };
